export enum TTBStatus {
  ALL = 'ALL',
  INITIALIZED = 'INITIALIZED',
  TRIAL_COMING = 'TRIAL_COMING',
  TRIAL_STARTED = 'TRIAL_STARTED',
  TRIAL_HALF_DONE = 'TRIAL_HALF_DONE',
  TRIAL_2_DAYS_LEFT = 'TRIAL_2_DAYS_LEFT',
  TRIAL_1_DAY_LEFT = 'TRIAL_1_DAY_LEFT',
  TIME_TO_DECIDE = 'TIME_TO_DECIDE',
  LAST_CHANCE = 'LAST_CHANCE',
  PRODUCT_RETURNING = 'PRODUCT_RETURNING',
  PRODUCT_PICKED_UP = 'PRODUCT_PICKED_UP',
  PRODUCT_RETURNED = 'PRODUCT_RETURNED',
  PRODUCT_RECEIVED = 'PRODUCT_RECEIVED',
  BOUGHT = 'BOUGHT',
  CANCELLED = 'CANCELLED',
  CHARGED = 'CHARGED',
  MISMATCHED_COMPONENT = 'MISMATCHED_COMPONENT',
  MISMATCHED_COMPONENT_RETURN_PICKED_UP = 'MISMATCHED_COMPONENT_RETURN_PICKED_UP',
  MISMATCHED_COMPONENT_RETURN_RECEIVED = 'MISMATCHED_COMPONENT_RETURN_RECEIVED',
  PRODUCT_RETURNING_TO_TM = 'PRODUCT_RETURNING_TO_TM',
  PRODUCT_RECEIVED_TO_TM = 'PRODUCT_RECEIVED_TO_TM',
  ONE_WEEK_LEFT_TO_FORCED_CHARGE = 'ONE_WEEK_LEFT_TO_FORCED_CHARGE',
  PAUSED = 'PAUSED',
}

export interface selectedNodesType {
  rtId?: string;
  name?: string;
  desc?: string;
  option?: any;
}

export interface cTmCustomconfiguratorNodesType {
  selectedNodes?: selectedNodesType[];
}

export interface ProductInfoType {
  type?: string;
  adjustedTax?: number;
  basePrice?: number;
  bonusProductLineItem?: boolean;
  gift?: boolean;
  itemId?: string;
  itemText?: string;
  price?: number;
  priceAfterItemDiscount?: number;
  priceAfterOrderDiscount?: number;
  productId?: string;
  productName?: string;
  quantity?: number;
  shipmentId?: string;
  tax?: number;
  taxBasis?: number;
  taxClassId?: string;
  taxRate?: number;
  cTmLineItemNo?: number;
  cTmCustomconfiguratorAtoModelName?: string;
  cTmCustomconfiguratorNodes?: cTmCustomconfiguratorNodesType;
}

export interface TTBTableDataType extends TTBType, TTBOtherType {}

export interface TTBType {
  id: string;
  userId?: string;
  orderId: string;
  status: string;
  productInfo?: ProductInfoType;
  pushedAt?: string;
  startedAt?: string;
  deliveredAt?: string;
  notifiedGVCAt?: string;
  notifiedEBSAt?: string;
  paymentAmount?: number;
  amountPaid?: number;
  amountTotal?: number;
  productStatusInfo?: string;
  carrierTrackingNumber?: string;
  shippedAt?: string;
  scheduledArrivalDate?: string;
  shipmentTrackingNumber?: string;
  shipmentTrackingUrl?: string;
  shipmentCarrierName?: string;
  shipmentSeventeentrackCarrierKey?: string;
  GVCReturnTrackingNumber?: string;
  GVCReturnTrackingCarrier?: string;
  GVCReturnToTMTrackingNumber?: string;
  GVCReturnToTMTrackingCarrier?: string;
  GVCReturnProductReceivedAt?: string;
  carrier?: string;
  shipmentDate?: string;
  GVCProductReturningToTMTrackingUrl?: string;
  GVCProductReturningTrackingUrl?: string;
  specsMismatchedReturnTrackingUrl?: string;
  specsMismatchedReturnTrackingNumber?: string;
  specsMismatchedReturnTrackingCarrier?: string;
  specsMismatchedReturnWrongComponentsTrackingUrl?: string;
  specsMismatchedReturnWrongComponentsTrackingCarrier?: string;
  specsMismatchedReturnWrongComponentsTrackingNumber?: string;
  email?: string;
  createdAt?: string;
  paused?: boolean;
  pauseReason?: string;
}

export interface TTBOtherType {
  index?: number;
  key?: number;
  price?: string;
  productType?: string;
  productId?: string;
  productName?: string;
  productImageUrl?: string;
}

export interface FilterTTBType {
  strSearch?: string;
  status?: string[];
  abnormalOrder?: string | number;
}

export const TTB_TIME = {
  AFTER_INITIALIZED_WARNING_ORG: 1,
  AFTER_INITIALIZED_WARNING_RED: 2,
  AFTER_TRIAL_COMING_WARNING_ORG: 6,
  AFTER_TRIAL_COMING_WARNING_RED: 7,
  AFTER_PRODUCT_RETURNING_WARNING_ORG: 20,
  AFTER_PRODUCT_RETURNING_WARNING_RED: 21,
  AFTER_PRODUCT_RECEIVED_WARNING_ORG: 3,
  AFTER_PRODUCT_RECEIVED_WARNING_RED: 4,
};

export enum TTB_WARNING {
  RED = 'red',
  ORG = 'orange',
  ORIGINAL = 'original',
}
